import React from "react";
import {
  EmptyState,
  EmptyStateBody,
  Bullseye
} from "@patternfly/react-core";
import { SearchIcon } from "@patternfly/react-icons";

export const NoResults = ({ title, message}) => {
  return (
    <Bullseye>
      <EmptyState
        titleText={title}
        headingLevel="h4"
        icon={SearchIcon}
      >
        <EmptyStateBody>
          {message}
        </EmptyStateBody>
      </EmptyState>
    </Bullseye>
  );
};